import { AffiliateProvider } from "@contexts/affiliate/AffiliateContext";
import CustomThemeProvider from "@providers/CustomThemeProvider";
import { ReactNode } from "react";
import Header from "./Header";
import * as S from "./styles";

interface AffiliateLayoutProps {
  children: ReactNode;
}

export default function OldAffiliateLayout({ children }: AffiliateLayoutProps) {
  return (
    <CustomThemeProvider storageKey="kirvano-theme">
      <S.Container>
        <AffiliateProvider>
          <Header />
          <S.ScrollableContainer>{children}</S.ScrollableContainer>
        </AffiliateProvider>
      </S.Container>
    </CustomThemeProvider>
  );
}
